if (typeof categoriesCarrusel !== 'function') {
    class categoriesCarrusel extends HTMLElement {
        constructor() {
            super();
            this.galleries = this.querySelectorAll('[data-collection-cards]');
            this.waitForSlick();    
        }

        waitForSlick() {
            const checkSlicknA = setInterval(() => {
                if (window.jQuery) {
                    clearInterval(checkSlicknA);
                    this.initSlick();
                }
            }, 100);
        }

        initSlick() {
            if (!this.galleries) return;

            this.galleries.forEach((gallery) => {
                if (window.jQuery) {
                    jQuery(gallery).slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                        infinite: true,
                        responsive: [
                          {
                            breakpoint: 1024,
                            settings: {
                              slidesToShow: 1.5,
                              slidesToScroll: 1,
                              infinite: true,
                              center: true
                            }
                          }
                        ]
                    });
                }

            })
            
            
        }
    }
    if (typeof customElements.get('carrusel-collections') === 'undefined') {
        customElements.define('carrusel-collections', categoriesCarrusel);
    }
}